module.exports = __webpack_public_path__ + "img/type-icon.f0b7c915.svg";